import React from 'react';
import NavRail from './NavRail';
import AppHeader from './AppHeader';

export function RedesignShell({
  children,
  activeNav,
  onNavClick,
  onLogout,
  userName,
  headerTitle,
  headerSubtitle,
  userTimestamp,
  unreadAlerts,
  onRefresh,
  onBell,
  onSearch,
  sidebarVariant = 'rail',
}) {
  return (
    <div className="flex h-screen bg-bg text-ink font-sans overflow-hidden">
      <NavRail
        variant={sidebarVariant}
        active={activeNav}
        onItemClick={onNavClick}
        onLogout={onLogout}
        userName={userName}
      />
      <div className="flex-1 flex flex-col min-w-0">
        <AppHeader
          title={headerTitle}
          subtitle={headerSubtitle}
          userName={userName}
          userTimestamp={userTimestamp}
          unreadAlerts={unreadAlerts}
          onRefresh={onRefresh}
          onBell={onBell}
          onSearch={onSearch}
        />
        <main className="flex-1 min-h-0 overflow-hidden">{children}</main>
      </div>
    </div>
  );
}

export default RedesignShell;
